import createLucideIcon from '../createLucideIcon';

/**
 * @component @name PanelLeftRightDashed
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYgMTBWOSIgLz4KICA8cGF0aCBkPSJNMTYgMTV2LTEiIC8+CiAgPHBhdGggZD0iTTE2IDIxdi0yIiAvPgogIDxwYXRoIGQ9Ik0xNiA1VjMiIC8+CiAgPHBhdGggZD0iTTggMTBWOSIgLz4KICA8cGF0aCBkPSJNOCAxNXYtMSIgLz4KICA8cGF0aCBkPSJNOCAyMXYtMiIgLz4KICA8cGF0aCBkPSJNOCA1VjMiIC8+CiAgPHJlY3QgeD0iMyIgeT0iMyIgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiByeD0iMiIgLz4KPC9zdmc+) - https://lucide.dev/icons/panel-left-right-dashed
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const PanelLeftRightDashed = createLucideIcon('panel-left-right-dashed', [
  ['path', { d: 'M16 10V9', key: '1s66rd' }],
  ['path', { d: 'M16 15v-1', key: 'kmf0wu' }],
  ['path', { d: 'M16 21v-2', key: '63oau2' }],
  ['path', { d: 'M16 5V3', key: '2dizs0' }],
  ['path', { d: 'M8 10V9', key: 'fun8gx' }],
  ['path', { d: 'M8 15v-1', key: 'fel0bl' }],
  ['path', { d: 'M8 21v-2', key: '1lp7tu' }],
  ['path', { d: 'M8 5V3', key: '19j4ll' }],
  ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', key: 'h1oib' }],
]);

export default PanelLeftRightDashed;
